export enum AlertStatus {
  unresolved = 0,
  inreview = 1,
  resolved = 2,
}
